import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import VoiceAssessmentPage from './pages/VoiceAssessmentPage';
import ResultsPage from './pages/ResultsPage';
import Header from './components/Header';
import Footer from './components/Footer';

function AppLayout() {
  const location = useLocation();
  // Hide header/footer during active assessment to avoid distraction
  const isAssessmentActive = location.pathname.startsWith('/assessment');

  return (
    <>
      {!isAssessmentActive && <Header />}
      <main className={!isAssessmentActive ? 'pt-[72px]' : ''}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/assessment/:department?" element={<VoiceAssessmentPage />} />
          <Route path="/results/:token" element={<ResultsPage />} />
        </Routes>
      </main>
      {!isAssessmentActive && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}
